/**
 * Which tenant routes stand in CapturePoint's shell (the left rail with Jobs, the company and Sign
 * out): the workbench and the job routes around it. Paige's own pages (the dashboard, settings, the
 * package) draw their own frame on the Paige scene instead
 * (IMPLEMENTATION.md, sell-ready sprint 2, rows 13 and 17c).
 */
export function inShell(routeId: string): boolean {
  return routeId.startsWith('/t/$tenant/jobs');
}
